import React from 'react';

import classnames from 'classnames';

import styles from './errorsvg.module.css';

const ErrorSVG = ({ className }) => (
    <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        className={classnames(styles.errorsvg, className)}
        xmlns="http://www.w3.org/2000/svg">
        <path d="M18 26H22V30H18V26ZM18 10H22V22H18V10ZM19.99 0C8.94 0 0 8.95 0 20C0 31.05 8.94 40 19.99 40C31.04 40 40 31.05 40 20C40 8.95 31.04 0 19.99 0ZM20 36C11.16 36 4 28.84 4 20C4 11.16 11.16 4 20 4C28.84 4 36 11.16 36 20C36 28.84 28.84 36 20 36Z" />
    </svg>
);

export default ErrorSVG;
